import * as Api from '@ViewModels';
import { StyleDeclarationValue, css } from 'aphrodite';
import { makeObservable, observable } from 'mobx';
import { inject, observer } from 'mobx-react';
import moment from 'moment';
import * as React from 'react';
import { withRouter } from 'react-router';
import { RouteComponentProps } from 'react-router-dom';
import {
	ErrorMessagesViewModelKey,
	IErrorMessageComponentProps,
	IUserSessionComponentProps,
	UserSessionViewModelKey,
} from '../../../../models/AppState';
import { IEventLoggingComponentProps } from '../../../../models/Logging';
import {
	AccountFilterCriteriaProperty,
	AccountSnapshotsViewModel,
	IAccountFilterCriteria,
} from '../../../../viewmodels/AdminViewModels';
import { styleSheet } from './styles';

interface IProps
	extends RouteComponentProps<any>,
		IUserSessionComponentProps,
		IErrorMessageComponentProps,
		IEventLoggingComponentProps {
	className?: string;
	styles?: StyleDeclarationValue[];
}

class _BenjaminsSection extends React.Component<IProps> {
	private mAccountSnapshotsVM: AccountSnapshotsViewModel;
	constructor(props: IProps) {
		super(props);

		makeObservable<_BenjaminsSection, 'mAccountSnapshotsVM'>(this, {
			mAccountSnapshotsVM: observable.ref,
		});

		this.mAccountSnapshotsVM = new AccountSnapshotsViewModel(props.userSession);
	}

	public componentDidMount() {
		const { errorMessages, logApiError } = this.props;
		const criteria: IAccountFilterCriteria = {
			criteria: [
				{
					property: AccountFilterCriteriaProperty.RenewalMonth,
					value: moment().format('YYYY-MM'),
				},
			],
			op: Api.FilterOperator.And,
		};
		this.mAccountSnapshotsVM.loadAccountSnapshotSummaryByMonth(criteria)?.catch((err: Api.IOperationResultNoValue) => {
			errorMessages.pushApiError(err);

			logApiError('RenewalLoadSnapshotsSummary', err);
		});
	}

	public render() {
		const { className, styles } = this.props;
		return (
			<div className={`${css(styleSheet.container, ...(styles || []))} benjamins-section ${className || ''}`}>
				<div>
					<div className={css(styleSheet.title)}>
						The
						<br />
						Benjamins
					</div>
					<div className={css(styleSheet.svgContainer)}>
						<svg width='226' height='166' fill='none' xmlns='http://www.w3.org/2000/svg'>
							<path
								opacity='.2'
								d='M30.582 84.096c-2.963.9-5.735 3.076-6.475 6.096-.846 3.471 1.105 6.97 1.387 10.534.912 11.676-15.622 19.914-13.263 31.383.936 4.561 4.722 7.915 8.451 10.687 5.976 4.425 12.605 8.335 19.947 9.439 11.143 1.677 22.786-3.253 33.617-.137 8.736 2.513 15.422 9.88 24.098 12.598 6.604 2.07 13.719 1.255 20.58.416 3.699-.451 7.575-.971 10.56-3.201 5.55-4.152 5.899-12.35 9.615-18.225 5.739-9.061 18.323-10.84 28.875-9.079 10.551 1.761 20.797 6.096 31.487 5.743 2.285-.077 4.625-.388 6.618-1.515 2.424-1.369 4.061-3.78 5.509-6.166a100.114 100.114 0 0014.399-49.574c.062-3.008-.044-6.147-1.452-8.802-1.781-3.36-5.34-5.37-8.882-6.721-8.508-3.253-17.905-3.785-26.241-7.453-8.04-3.538-14.552-9.743-21.554-15.061A114.544 114.544 0 00120.572 23.9c-4.021-.78-8.195-1.338-12.19-.437-4.604 1.039-8.572 3.922-12.14 7.025-9.493 8.257-17.1 18.444-25.848 27.493a147.352 147.352 0 01-19.637 17.012c-3.237 2.344-6.678 5.127-10.285 6.86-3.302 1.585-6.399 1.185-9.89 2.242z'
								fill='#6C63FF'
							/>
							<path d='M72 11s-8.489 11.914-2.416 25.8C75.657 50.689 59 73 59 73' stroke='#535461' strokeWidth='2' />
							<path
								d='M76.722 6.17C76.019 9.197 72.656 11 72.656 11s-2.221-3.105-1.519-6.131c.703-3.027 2.519-5.19 4.067-4.83 1.547.36 2.22 3.105 1.518 6.131z'
								fill='#8ED16F'
							/>
							<path
								d='M74.098 5.718c.224-.963.113-1.812-.248-1.896-.36-.084-.834.629-1.058 1.592-.224.963-.113 1.811.248 1.895.36.084.834-.628 1.058-1.591z'
								fill='#8ED16F'
							/>
							<path
								opacity='.3'
								d='M74.098 5.718c.224-.963.113-1.812-.248-1.896-.36-.084-.834.629-1.058 1.592-.224.963-.113 1.811.248 1.895.36.084.834-.628 1.058-1.591z'
								fill='#000'
							/>
							<path
								d='M75.454 19.692c-3.01 1-6.454-.752-6.454-.752s1.44-3.371 4.453-4.369c3.014-.997 5.9-.652 6.454.752.555 1.404-1.441 3.369-4.453 4.369z'
								fill='#8ED16F'
							/>
							<path
								d='M74.006 17.513c.929-.336 1.58-.89 1.454-1.239-.126-.348-.981-.358-1.91-.022-.929.336-1.58.891-1.454 1.24.126.348.981.358 1.91.021z'
								fill='#8ED16F'
							/>
							<path
								opacity='.3'
								d='M74.006 17.513c.929-.336 1.58-.89 1.454-1.239-.126-.348-.981-.358-1.91-.022-.929.336-1.58.891-1.454 1.24.126.348.981.358 1.91.021z'
								fill='#000'
							/>
							<path
								d='M74.454 29.692c-3.01 1-6.454-.752-6.454-.752s1.44-3.371 4.453-4.369c3.014-.997 5.9-.652 6.454.752.555 1.404-1.441 3.371-4.453 4.369z'
								fill='#8ED16F'
							/>
							<path
								d='M73.351 28.536c.93-.335 1.582-.889 1.456-1.237-.125-.349-.98-.36-1.91-.025-.93.335-1.582.889-1.456 1.238.125.348.98.36 1.91.024z'
								fill='#8ED16F'
							/>
							<path
								opacity='.3'
								d='M73.351 28.536c.93-.335 1.582-.889 1.456-1.237-.125-.349-.98-.36-1.91-.025-.93.335-1.582.889-1.456 1.238.125.348.98.36 1.91.024z'
								fill='#000'
							/>
							<path
								d='M78.454 43.692c-3.01 1-6.454-.752-6.454-.752s1.44-3.371 4.453-4.369c3.014-.997 5.9-.652 6.454.752.555 1.404-1.441 3.376-4.453 4.369z'
								fill='#8ED16F'
							/>
							<path
								d='M76.811 41.281c.93-.335 1.582-.889 1.456-1.238-.125-.348-.98-.36-1.91-.025-.93.335-1.582.89-1.456 1.238.125.349.98.36 1.91.025z'
								fill='#8ED16F'
							/>
							<path
								opacity='.3'
								d='M76.811 41.281c.93-.335 1.582-.889 1.456-1.238-.125-.348-.98-.36-1.91-.025-.93.335-1.582.89-1.456 1.238.125.349.98.36 1.91.025z'
								fill='#000'
							/>
							<path
								d='M75.454 54.692c-3.01 1-6.454-.752-6.454-.752s1.44-3.371 4.453-4.369c3.014-.997 5.9-.652 6.454.752.555 1.404-1.44 3.371-4.453 4.369z'
								fill='#8ED16F'
							/>
							<path
								d='M74.567 52.733c.929-.336 1.58-.89 1.454-1.24-.126-.348-.981-.357-1.91-.021-.929.336-1.58.89-1.454 1.24.126.347.981.357 1.91.021z'
								fill='#8ED16F'
							/>
							<path
								opacity='.3'
								d='M74.567 52.733c.929-.336 1.58-.89 1.454-1.24-.126-.348-.981-.357-1.91-.021-.929.336-1.58.89-1.454 1.24.126.347.981.357 1.91.021z'
								fill='#000'
							/>
							<path
								d='M61.26 22.83c2.068 2.35 5.725 2.167 5.725 2.167s.3-3.998-1.768-6.346c-2.069-2.35-4.632-3.317-5.725-2.166-1.094 1.15-.301 3.997 1.767 6.346z'
								fill='#8ED16F'
							/>
							<path
								d='M64.886 22.16c.267-.258-.073-1.043-.76-1.754-.686-.711-1.458-1.08-1.725-.822-.266.257.074 1.043.76 1.754.687.711 1.459 1.08 1.725.822z'
								fill='#8ED16F'
							/>
							<path
								opacity='.3'
								d='M64.886 22.16c.267-.258-.073-1.043-.76-1.754-.686-.711-1.458-1.08-1.725-.822-.266.257.074 1.043.76 1.754.687.711 1.459 1.08 1.725.822z'
								fill='#000'
							/>
							<path
								d='M60.26 58.83c2.068 2.35 5.725 2.167 5.725 2.167s.3-3.998-1.768-6.346c-2.069-2.35-4.632-3.317-5.725-2.167-1.094 1.15-.301 3.998 1.767 6.347z'
								fill='#8ED16F'
							/>
							<path
								d='M63.628 58.147c.266-.258-.074-1.043-.76-1.754-.686-.712-1.459-1.08-1.725-.822-.267.257.074 1.043.76 1.754.686.711 1.459 1.079 1.725.822z'
								fill='#8ED16F'
							/>
							<path
								opacity='.3'
								d='M63.628 58.147c.266-.258-.074-1.043-.76-1.754-.686-.712-1.459-1.08-1.725-.822-.267.257.074 1.043.76 1.754.686.711 1.459 1.079 1.725.822z'
								fill='#000'
							/>
							<path
								d='M62.826 35.376C65.545 36.812 69 35.32 69 35.32s-.952-3.818-3.668-5.254c-2.716-1.436-5.482-1.422-6.174.057-.692 1.479.95 3.818 3.668 5.254z'
								fill='#8ED16F'
							/>
							<path
								d='M66.057 33.777c.165-.332-.417-.959-1.301-1.4-.884-.441-1.735-.53-1.9-.199-.166.332.417.958 1.301 1.4.884.441 1.735.53 1.9.199z'
								fill='#8ED16F'
							/>
							<path
								opacity='.3'
								d='M66.057 33.777c.165-.332-.417-.959-1.301-1.4-.884-.441-1.735-.53-1.9-.199-.166.332.417.958 1.301 1.4.884.441 1.735.53 1.9.199z'
								fill='#000'
							/>
							<path
								d='M64.826 48.376C67.545 49.812 71 48.32 71 48.32s-.952-3.818-3.668-5.254c-2.717-1.436-5.482-1.422-6.174.057-.692 1.479.96 3.832 3.668 5.254z'
								fill='#8ED16F'
							/>
							<path
								d='M67.24 46.448c.165-.332-.418-.959-1.302-1.4-.884-.442-1.735-.53-1.9-.199-.166.332.417.958 1.301 1.4.884.441 1.735.53 1.9.199z'
								fill='#8ED16F'
							/>
							<path
								opacity='.3'
								d='M67.24 46.448c.165-.332-.418-.959-1.302-1.4-.884-.442-1.735-.53-1.9-.199-.166.332.417.958 1.301 1.4.884.441 1.735.53 1.9.199z'
								fill='#000'
							/>
							<path
								d='M30.135 36s16.295 16.471 7.096 40.913C28.032 101.355 53 142 53 142s-.268-.04-.764-.128C18.764 135.901 2.144 97.209 20.75 68.466 27.659 57.78 33.349 45.245 30.135 36z'
								fill='#8ED16F'
							/>
							<path
								d='M0 102.204s18.912-2.97 20.635 13.746C22.358 132.666 57 134.984 57 134.984s-.235.153-.65.427C27.746 153.936.404 147.206 4.524 122.617 6.06 113.472 5.933 104.291 0 102.204z'
								fill='#8ED16F'
							/>
							<path
								d='M0 103.226s18.894-2.956 20.616 13.674c1.722 16.63 36.332 18.936 36.332 18.936l-.65.424C27.722 154.69.404 147.995 4.52 123.533c1.534-9.098 1.408-18.232-4.52-20.307z'
								fill='#fff'
								opacity='.3'
							/>
							<path
								d='M24 102c2.761 0 5-6.044 5-13.5S26.761 75 24 75s-5 6.044-5 13.5 2.239 13.5 5 13.5z'
								fill='#8ED16F'
							/>
							<path
								opacity='.3'
								d='M24 102c2.761 0 5-6.044 5-13.5S26.761 75 24 75s-5 6.044-5 13.5 2.239 13.5 5 13.5z'
								fill='#000'
							/>
							<path
								d='M23.973 137.717c1.353-1.353.008-4.893-3.003-7.906-3.01-3.013-6.549-4.358-7.901-3.004-1.353 1.354-.01 4.893 3.002 7.906 3.011 3.013 6.549 4.358 7.902 3.004z'
								fill='#8ED16F'
							/>
							<path
								opacity='.3'
								d='M23.973 137.717c1.353-1.353.008-4.893-3.003-7.906-3.01-3.013-6.549-4.358-7.901-3.004-1.353 1.354-.01 4.893 3.002 7.906 3.011 3.013 6.549 4.358 7.902 3.004z'
								fill='#000'
							/>
							<path
								d='M168.446 62H46.554C43.486 62 41 64.5 41 67.584v71.832C41 142.5 43.486 145 46.554 145h121.892c3.068 0 5.554-2.5 5.554-5.584V67.584C174 64.5 171.514 62 168.446 62z'
								fill='url(#paint0_linear)'
							/>
							<rect x='42' y='63' width='129' height='80' rx='13' fill='#046CB6' />
							<path fill='#00528C' d='M42 77h129v15H42z' />
							<path fill='#D6D6E3' d='M55 102h105v7H55z' />
							<path
								d='M63.5 137c5.799 0 10.5-4.701 10.5-10.5S69.299 116 63.5 116 53 120.701 53 126.5 57.701 137 63.5 137z'
								fill='#00528C'
							/>
							<path
								fillRule='evenodd'
								clipRule='evenodd'
								d='M166.022 43.782a2.245 2.245 0 01-.985-1.251c-.633-2.25 6.947-1.182 9.98-.67a2.246 2.246 0 011.697 1.34l.013.032 4.536 10.71v-.315c-.018-1.523.291-5.289 3.709-5.824 0 0 2.959.4 4.987-.547.086-.04.166-.081.247-.126-2.279-3.905-5.686-7.528-5.686-7.528s-5.714-2.17-7.375-4.719a2.274 2.274 0 01-.431-1.571c.454-3.15 9.507 3.476 9.507 3.476l3.621 3.37 2.252 1.892.03.025c.007-.053.007-.1.007-.15 0-.05 0-.103.006-.17.014-.132.014-.268.014-.403v-.232l-.05-.039a5.496 5.496 0 01-.408-.338l-.042-.037c.021-.128.039-.258.058-.388a6.14 6.14 0 01-1.932-4.081c-.013-.132-.013-.264-.013-.399a6.114 6.114 0 01.921-3.245c.14-.223.294-.437.461-.64-.991-.173-1.94-.725-2.387-1.61v-.016a.897.897 0 01-.12-.464c.013-.258.191-.457.368-.656.065-.073.13-.146.187-.222.194-.258.297-.566.401-.873.094-.279.187-.558.348-.8.679-1.024 2.146-1.023 3.385-1.023h.073c.832-.004 1.664-.075 2.496-.145 1.011-.085 2.023-.17 3.035-.138 1.846.06 3.792.582 5.011 1.959 1.468 1.655 1.532 4.084 1.521 6.29-.007.909-.039 1.905-.622 2.6l-.028.033c-.07.082-.147.158-.223.234a3.218 3.218 0 00-.291.318c-.14.191-.254.4-.339.621a4.97 4.97 0 01-.445.927 1.543 1.543 0 01-.071.095c-.609.77-1.715.967-2.706 1.096.062-.018.101-.104.125-.25.011-.09.018-.182.02-.273-.038.043-.077.09-.116.137a5.45 5.45 0 01-.172.199l-.131.139-.014.119c-.01.082-.021.164-.021.247-.129 1.544-.041 3.19.563 4.517l1.813 1.034c.467.266.994.406 1.531.406h4.635c.4.002.795.08 1.166.231h.023l.044.026c.507.213.947.563 1.27 1.01a6.242 6.242 0 011.104 3.802c.034 1.539-.378 3.49-1.613 5.942-2.146 4.26-2.665 11.789-2.665 17.963.005 5.447.401 9.783.401 9.783h-.021c.021.153.021.232.021.232s-.175-.03-.502-.08l-.309-.05.032.095a35.753 35.753 0 011.74 14.918c-1.016 9.998-1.357 20.109-1.357 20.109v25.606l-.212.093-.15.067c1.33 1.583 3.867 4.474 4.61 4.392.444-.051 1.147.353 1.687.877.696.674 1.115 1.555.35 1.933-.535.268-2.074.5-3.976.5-2.932.021-6.751-.517-9.097-2.297v-.336l.055.042v-1.952c-.108.074-.21.158-.304.251a.32.32 0 00-.09.143l-.011-.146a.23.23 0 00-.046.091s-.033-.397-.095-1.002l.002-.024c.001-.014.003-.027-.002-.071l-.009-.067a.897.897 0 01-.014-.139 40.966 40.966 0 00-.237-1.805 19.454 19.454 0 00-.484-2.332 16.084 16.084 0 01-.623-4.48v-15.358c0-1.465-1.025-17.796-3.302-23.507a7.039 7.039 0 00-.501-1.038 3.05 3.05 0 00-.352-.524 1.622 1.622 0 00-.231-.204l-.062.387.055.067c-.412 2.654-2.742 17.72-2.535 21.507l.054.951c.31 5.429 1.218 21.354-.054 22.301l-1.132 3.82-.412-.137v-.035l-.108-.035v3.862c-.66 1.119-6.631 2.16-9.996 2.16a7.984 7.984 0 01-1.718-.139c-.97-.23-1.279-.702-1.184-1.219a.733.733 0 00.041.136c.023-.257.116-.502.27-.709l.046-.065.032-.044a3.933 3.933 0 011.874-1.249c1.242-.387 2.858-2.686 3.75-4.077a1.308 1.308 0 00-.3.088v-.081l-.064.025v-.076l.009-.112c.029-.35.096-1.173.18-2.294.339-4.64.943-14.421.21-17.223a13.141 13.141 0 01-.406-3.333v-7.417l-2.249-15.925a18.581 18.581 0 01-.157-3.551c.117-2.248.364-6.142.793-9.271.032-.241.066-.477.101-.707l-.074.023s.019-.077.049-.232l-.049.016s1.266-6.204 1.284-11.192c.003-.84-.048-1.68-.152-2.513-.025-.183-.046-.37-.065-.56a20.797 20.797 0 01-.087-2.059c.014-1.892.173-3.78.477-5.648a48.443 48.443 0 01.463-2.566l-.336 1.175s-2.344 2.22-4.343.202a6.13 6.13 0 01-.184-.202c-2.037-2.348-3.282-8.65-3.395-9.996-.085-1.113-1.346-6.059-2.16-7.746-.17-.355-.325-.566-.442-.566-.054 0-.145.003-.269.007-1.153.035-5.095.156-7.007-1.115zm18.205 102.779a1.957 1.957 0 00-.2.038l.18-.005.02-.033z'
								fill='url(#paint1_linear)'
							/>
							<path
								d='M207.372 144s4.272 5.684 5.26 5.568c.987-.117 3.286 2.202 1.973 2.911-1.313.708-8.874 1.159-12.605-1.856v-4.544l5.372-2.079zm-23.667 1s-2.633 4.358-4.462 4.891c-1.828.534-3.432 2.446-1.029 2.978 2.403.531 10.987-.638 11.786-1.915v-5.636l-6.295-.318z'
								fill='#ACA9C9'
							/>
							<path
								d='M181.184 100.401l2.216 15.674v7.287a12.955 12.955 0 00.401 3.279c.723 2.759.129 12.383-.207 16.95-.11 1.489-.194 2.442-.194 2.442 1.449-.664 7.584 1.436 7.584 1.436l.62-2.093.495-1.665c1.339-.994.233-18.793 0-22.893-.152-2.8 1.108-11.879 1.915-17.32.233-1.538.422-2.775.536-3.52.073-.462.112-.72.112-.72.246.2.451.444.602.72.192.327.357.669.492 1.022 2.244 5.622 3.266 21.693 3.266 23.125v15.114a15.817 15.817 0 00.614 4.41c.276 1.046.478 2.11.604 3.184.159 1.2.233 2.167.233 2.167.112-.664 7.026-3.649 7.026-3.649v-25.206s.334-9.944 1.339-19.79a35.007 35.007 0 00-2.078-15.685 21.31 21.31 0 00-.7-1.67h-22.777c-.382.072-.699.835-.986 1.993-.187.777-.35 1.73-.492 2.775-.423 3.078-.665 6.91-.782 9.125a18.29 18.29 0 00.161 3.508z'
								fill='#618FD8'
							/>
							<path
								d='M207.913 146.15v-25.066s.335-9.888 1.344-19.68c1.01-9.792-2.81-17.261-2.81-17.261h.447s3.806 7.476 2.811 17.261c-.996 9.785-1.345 19.68-1.345 19.68v25.066s-6.942 2.969-7.055 3.629c0 0 0-.147-.035-.4 1.513-1.032 6.643-3.229 6.643-3.229zm-23.124.539c-.211.004-.42.046-.616.124v-.111c.205-.02.411-.024.616-.013zm7.672-2.185c1.344-.989.234-18.69 0-22.767-.235-4.077 2.576-21.437 2.576-21.437.147.111.277.243.387.391-.413 2.594-2.718 17.341-2.514 21.046.234 4.068 1.345 21.769 0 22.767l-1.119 3.737-.408-.134 1.078-3.603z'
								opacity='.1'
								fill='#000'
							/>
							<path
								d='M186 54.675l-2.455 8.284s-2.583 2.342-4.695 0c-2.112-2.341-3.413-8.62-3.541-9.964-.127-1.344-1.996-8.284-2.701-8.284-.704 0-7.747.447-8.569-2.342-.658-2.243 7.204-1.17 10.352-.667a2.313 2.313 0 011.76 1.334l4.828 10.995s2.556-2.827 5.021.644zM200.758 36s-2.753 8.295.742 11.25C204.996 50.203 189 51 189 51l2.171-2.215s1.535-6.534.476-11.989l9.111-.796z'
								fill='#F7C4A7'
							/>
							<path
								opacity='.1'
								d='M196.888 48.457s2.869-.703 2.869-1.457l2.542 1.457h6.388s4.655 2.59.758 10.367c-3.897 7.777-2.164 26.88-2.164 26.88S193.426 83.219 181.952 87c0 0 1.732-8.531 1.082-13.39-.65-4.858 1.082-11.662 1.082-11.662l.974-4.104s-.055-3.84-4.06-1.89c0 0-.595-5.561 3.519-6.21 0 0 4.754.649 6.169-1.728 0 .01 3.141 1.846 6.17.44z'
								fill='#000'
							/>
							<path
								d='M196.888 47.457s2.869-.703 2.869-1.457l1.863 1.068c.446.255.95.389 1.463.389h4.467a2.947 2.947 0 012.394 1.215c1.025 1.439 1.945 4.276-.499 9.153-3.896 7.774-2.164 26.879-2.164 26.879S193.426 82.219 181.952 86c0 0 1.732-8.531 1.082-13.39-.65-4.858 1.082-11.646 1.082-11.646l.974-4.104s-.055-3.84-4.06-1.89c0 0-.58-5.408 3.349-6.18a1.11 1.11 0 01.333-.023c.84.088 4.754.37 6.009-1.746-.003.002 3.138 1.839 6.167.436z'
								fill='#E14B5A'
							/>
							<path
								opacity='.1'
								d='M208.57 56.984s-3.492 2.286-9.166 0c0 0-6.22-2.39-8.185-7.086-1.965-4.696 9.929.8 9.929.8s2.51 0 3.273-.57c.762-.572 6.112 4.341 4.149 6.856z'
								fill='#000'
							/>
							<path
								d='M208.568 56.033s-3.505 2.176-9.202 0c0 0-6.243-2.277-8.216-6.749-1.973-4.471-6.572-9.369-6.572-9.369s-7.996-3.048-7.561-6.095c.435-3.046 9.202 3.374 9.202 3.374l3.506 3.265 11.392 9.579s2.52 0 3.286-.544c.765-.544 6.136 4.143 4.165 6.539z'
								fill='#F7C4A7'
							/>
							<path
								opacity='.1'
								d='M191 37.73l10-.73a18.812 18.812 0 00-1.044 4.247c-2.418 2.25-6.4 2.346-8.951.218a9.16 9.16 0 00-.005-3.734z'
								fill='#000'
							/>
							<path d='M195.5 43a6.5 6.5 0 100-13 6.5 6.5 0 000 13z' fill='#F7C4A7' />
							<path
								opacity='.1'
								d='M198.249 37.812c-.346-.59.358-1.357.126-2.002-.213-.594-1.065-.696-1.351-1.25-.225-.449 0-.998-.09-1.493-.128-.638-.795-1.034-1.428-1.067-.633-.032-1.243.211-1.844.42-.98.341-2.011.603-3.038.483-1.027-.121-2.052-.696-2.509-1.64a.952.952 0 01-.115-.45c.018-.349.329-.588.529-.866.352-.485.392-1.146.712-1.652.653-1.03 2.088-1.005 3.281-1.01 1.757 0 3.505-.338 5.261-.278 1.757.06 3.604.573 4.768 1.933 1.396 1.636 1.459 4.03 1.448 6.21 0 .899-.036 1.876-.592 2.57-.162.201-.361.368-.516.575-.338.464-.428 1.058-.745 1.529-.563.837-1.663 1.041-2.642 1.176.288-.04.049-2.028 0-2.211-.189-.914-.394-.896-1.255-.977z'
								fill='#000'
							/>
							<path
								d='M198.249 37.812c-.346-.59.358-1.357.126-2.002-.213-.594-1.065-.696-1.351-1.25-.225-.449 0-.998-.09-1.493-.128-.638-.795-1.034-1.428-1.067-.633-.032-1.243.211-1.844.42-.98.341-2.011.603-3.038.483-1.027-.121-2.052-.696-2.509-1.64a.952.952 0 01-.115-.45c.018-.349.329-.588.529-.866.352-.485.392-1.146.712-1.652.653-1.03 2.088-1.005 3.281-1.01 1.757 0 3.505-.338 5.261-.278 1.757.06 3.604.573 4.768 1.933 1.396 1.636 1.459 4.03 1.448 6.21 0 .899-.036 1.876-.592 2.57-.162.201-.361.368-.516.575-.338.464-.428 1.058-.745 1.529-.563.837-1.663 1.041-2.642 1.176.288-.04.049-2.028 0-2.211-.189-.926-.394-.898-1.255-.977z'
								fill='#281C1C'
							/>
							<path
								opacity='.1'
								d='M208.697 57s-2.936-7.685-5.219-7.903c-2.283-.218 4.348 0 4.348 0L210 53.048 208.697 57z'
								fill='#000'
							/>
							<path
								d='M208.697 57s-2.936-7.685-5.219-7.903c-2.283-.218 4.348 0 4.348 0L210 53.048 208.697 57z'
								fill='#E14B5A'
							/>
							<path
								d='M200 147.011a39.2 39.2 0 01.225 1.989c.108-.609 6.775-3.349 6.775-3.349v-1.649a3.19 3.19 0 00-.508.023c-1.294.164-2.493.756-3.599 1.388a33.168 33.168 0 01-2.893 1.598z'
								fill='#618FD8'
							/>
							<path
								opacity='.3'
								d='M200 147.011a39.2 39.2 0 01.225 1.989c.108-.609 6.775-3.349 6.775-3.349v-1.649a3.19 3.19 0 00-.508.023c-1.294.164-2.493.756-3.599 1.388a33.168 33.168 0 01-2.893 1.598z'
								fill='#000'
							/>
							<path
								d='M184 146.572c1.413-.66 7.395 1.428 7.395 1.428l.605-2.081a31.957 31.957 0 01-3.1-.798 10.168 10.168 0 01-1.392-.519 9.137 9.137 0 00-.929-.437c-.78-.271-1.592-.156-2.392-.021a173.002 173.002 0 01-.187 2.428z'
								fill='#618FD8'
							/>
							<path
								opacity='.3'
								d='M184 146.572c1.413-.66 7.395 1.428 7.395 1.428l.605-2.081a31.957 31.957 0 01-3.1-.798 10.168 10.168 0 01-1.392-.519 9.137 9.137 0 00-.929-.437c-.78-.271-1.592-.156-2.392-.021a173.002 173.002 0 01-.187 2.428z'
								fill='#000'
							/>
							<path
								opacity='.4'
								d='M213.602 153.048a.747.747 0 00.376-.509c.084.365-.077.747-.376.892-1.315.768-8.872 1.279-12.602-2.048V151c3.73 3.327 11.287 2.816 12.602 2.048zm-35.388.382c2.394.674 10.987-.81 11.786-2.43v.404c-.802 1.619-9.383 3.104-11.786 2.429-.981-.282-1.295-.846-1.197-1.464.077.457.436.835 1.197 1.061z'
								fill='#fff'
							/>
							<path opacity='.1' d='M193 72.352s-2.579-.792-3.283 0C189.014 73.144 183 75 183 75' fill='#000' />
							<path fill='#8ED16F' d='M177 41.125h-12v-.251h12z' />
							<path fill='#8ED16F' d='M177 41.125h-12v-.251h12z' />
							<path opacity='.1' fill='#000' d='M177 41.125h-12v-.251h12z' />
							<path fill='#8ED16F' d='M177 42.125h-12v-.251h12z' />
							<path fill='#8ED16F' d='M177 42.125h-12v-.251h12z' />
							<path opacity='.1' fill='#000' d='M177 42.125h-12v-.251h12z' />
							<path fill='#8ED16F' d='M177 43.125h-12v-.251h12z' />
							<path fill='#8ED16F' d='M177 43.125h-12v-.251h12z' />
							<path opacity='.1' fill='#000' d='M177 43.125h-12v-.251h12z' />
							<path fill='#8ED16F' d='M177 43.125h-12v-.251h12zm0 1h-12v-.251h12z' />
							<path opacity='.1' fill='#000' d='M177 44.125h-12v-.251h12z' />
							<path
								fill='#8ED16F'
								d='M177 39.125h-12v-.251h12zm5.706 2.193l-9.125-7.593.161-.193 9.125 7.594-.161.192zm-8.319-3.995l-9.125-7.593.16-.193 9.125 7.593-.16.193z'
							/>
							<path fill='#8ED16F' d='M177 39.125h-12v-.251h12z' />
							<path opacity='.1' fill='#000' d='M177 39.125h-12v-.251h12z' />
							<path fill='#8ED16F' d='M177 40.125h-12v-.251h12z' />
							<path fill='#8ED16F' d='M177 40.125h-12v-.251h12z' />
							<path opacity='.1' fill='#000' d='M177 40.125h-12v-.251h12z' />
							<path fill='#8ED16F' d='M177 40.125h-12v-.251h12z' />
							<path fill='#8ED16F' d='M177 40.125h-12v-.251h12z' />
							<path opacity='.1' fill='#000' d='M177 40.125h-12v-.251h12z' />
							<path fill='#8ED16F' d='M177 40.125h-12v-.251h12zm0 1h-12v-.251h12z' />
							<path opacity='.1' fill='#000' d='M177 41.125h-12v-.251h12z' />
							<path d='M167.935 51.935l-4.253-.79 1.539-8.293 4.253.79-1.539 8.293z' fill='#8ED16F' />
							<path
								d='M167.509 47.582c.178-.965-.067-1.819-.548-1.908-.481-.09-1.016.62-1.195 1.584-.179.964.066 1.819.547 1.908.481.09 1.017-.62 1.196-1.584z'
								fill='#8ED16F'
							/>
							<path
								opacity='.1'
								d='M167.509 47.582c.178-.965-.067-1.819-.548-1.908-.481-.09-1.016.62-1.195 1.584-.179.964.066 1.819.547 1.908.481.09 1.017-.62 1.196-1.584z'
								fill='#000'
							/>
							<path d='M168.662 69.439l-4.252-.79 1.539-8.293 4.252.79-1.539 8.293z' fill='#8ED16F' />
							<path
								d='M168.234 65.084c.179-.965-.066-1.819-.547-1.908-.482-.09-1.017.62-1.196 1.584-.179.965.066 1.819.547 1.908.482.09 1.017-.62 1.196-1.584z'
								fill='#8ED16F'
							/>
							<path
								opacity='.1'
								d='M168.234 65.084c.179-.965-.066-1.819-.547-1.908-.482-.09-1.017.62-1.196 1.584-.179.965.066 1.819.547 1.908.482.09 1.017-.62 1.196-1.584z'
								fill='#000'
							/>
							<path d='M146.971 29.43l2.058-3.806 7.414 4.015-2.058 3.806-7.414-4.015z' fill='#8ED16F' />
							<path
								d='M153.991 30.55c.235-.43-.274-1.162-1.137-1.633-.862-.47-1.752-.503-1.987-.072-.235.431.274 1.162 1.136 1.633.863.471 1.753.503 1.988.072z'
								fill='#8ED16F'
							/>
							<path
								opacity='.1'
								d='M153.991 30.55c.235-.43-.274-1.162-1.137-1.633-.862-.47-1.752-.503-1.987-.072-.235.431.274 1.162 1.136 1.633.863.471 1.753.503 1.988.072z'
								fill='#000'
							/>
							<path d='M130.692 104.542l2.058-3.806 7.414 4.014-2.058 3.806-7.414-4.014z' fill='#8ED16F' />
							<path
								d='M136.965 105.543c.233-.431-.277-1.159-1.139-1.626-.862-.466-1.75-.496-1.983-.065-.233.431.277 1.158 1.139 1.625.862.467 1.75.496 1.983.066z'
								fill='#8ED16F'
							/>
							<path
								opacity='.1'
								d='M136.965 105.543c.233-.431-.277-1.159-1.139-1.626-.862-.466-1.75-.496-1.983-.065-.233.431.277 1.158 1.139 1.625.862.467 1.75.496 1.983.066z'
								fill='#000'
							/>
							<path d='M120.732 42.558l2.058-3.806 7.414 4.014-2.058 3.806-7.414-4.014z' fill='#8ED16F' />
							<path
								d='M127.003 43.554c.233-.43-.277-1.158-1.139-1.625-.862-.467-1.75-.496-1.983-.065-.233.43.277 1.158 1.139 1.625.862.467 1.75.496 1.983.065z'
								fill='#8ED16F'
							/>
							<path
								opacity='.1'
								d='M127.003 43.554c.233-.43-.277-1.158-1.139-1.625-.862-.467-1.75-.496-1.983-.065-.233.43.277 1.158 1.139 1.625.862.467 1.75.496 1.983.065z'
								fill='#000'
							/>
							<path d='M133.215 29.43l2.059-3.807 7.413 4.015-2.058 3.806-7.414-4.015z' fill='#8ED16F' />
							<path
								d='M139.486 30.426c.233-.43-.277-1.158-1.139-1.625-.862-.467-1.75-.496-1.983-.065-.233.43.277 1.158 1.139 1.625.863.467 1.75.496 1.983.065z'
								fill='#8ED16F'
							/>
							<path
								opacity='.1'
								d='M139.486 30.426c.233-.43-.277-1.158-1.139-1.625-.862-.467-1.75-.496-1.983-.065-.233.43.277 1.158 1.139 1.625.863.467 1.75.496 1.983.065z'
								fill='#000'
							/>
							<path d='M143.437 41.584l4.3-.47.916 8.385-4.299.47-.917-8.385z' fill='#8ED16F' />
							<path
								d='M146.181 47.314c.487-.053.795-.887.688-1.862-.106-.975-.587-1.722-1.074-1.669-.486.053-.794.887-.688 1.862.107.975.588 1.722 1.074 1.67z'
								fill='#8ED16F'
							/>
							<path
								opacity='.1'
								d='M146.181 47.314c.487-.053.795-.887.688-1.862-.106-.975-.587-1.722-1.074-1.669-.486.053-.794.887-.688 1.862.107.975.588 1.722 1.074 1.67z'
								fill='#000'
							/>
							<path d='M172.915 87.497l4.3-.47.916 8.385-4.3.47-.916-8.385z' fill='#8ED16F' />
							<path
								d='M175.661 93.227c.487-.053.795-.887.688-1.862-.106-.975-.587-1.723-1.074-1.67-.486.054-.794.888-.688 1.863.107.975.588 1.722 1.074 1.669z'
								fill='#8ED16F'
							/>
							<path
								opacity='.1'
								d='M175.661 93.227c.487-.053.795-.887.688-1.862-.106-.975-.587-1.723-1.074-1.67-.486.054-.794.888-.688 1.863.107.975.588 1.722 1.074 1.669z'
								fill='#000'
							/>
							<path d='M128.843 62.731l2.058-3.806 7.414 4.014-2.058 3.806-7.414-4.014z' fill='#8ED16F' />
							<path
								d='M135.113 63.731c.233-.43-.277-1.158-1.14-1.625-.862-.467-1.75-.496-1.983-.066-.233.431.278 1.159 1.14 1.626.862.467 1.75.496 1.983.065z'
								fill='#8ED16F'
							/>
							<path
								opacity='.1'
								d='M135.113 63.731c.233-.43-.277-1.158-1.14-1.625-.862-.467-1.75-.496-1.983-.066-.233.431.278 1.159 1.14 1.626.862.467 1.75.496 1.983.065z'
								fill='#000'
							/>
							<path d='M110.134 57.384l2.059-3.806 7.414 4.015-2.059 3.806-7.414-4.015z' fill='#8ED16F' />
							<path
								d='M117.021 58.637c.235-.43-.274-1.162-1.136-1.633-.863-.47-1.753-.503-1.988-.072-.235.431.274 1.162 1.137 1.633.863.471 1.752.503 1.987.072z'
								fill='#8ED16F'
							/>
							<path
								opacity='.1'
								d='M117.021 58.637c.235-.43-.274-1.162-1.136-1.633-.863-.47-1.753-.503-1.988-.072-.235.431.274 1.162 1.137 1.633.863.471 1.752.503 1.987.072z'
								fill='#000'
							/>
							<path d='M104.142 147.398l2.059-3.806 7.414 4.014-2.059 3.806-7.414-4.014z' fill='#8ED16F' />
							<path
								d='M110.413 148.396c.233-.431-.277-1.159-1.139-1.626-.862-.466-1.75-.496-1.983-.065-.233.431.277 1.159 1.139 1.625.863.467 1.75.496 1.983.066z'
								fill='#8ED16F'
							/>
							<path
								opacity='.1'
								d='M110.413 148.396c.233-.431-.277-1.159-1.139-1.626-.862-.466-1.75-.496-1.983-.065-.233.431.277 1.159 1.139 1.625.863.467 1.75.496 1.983.066z'
								fill='#000'
							/>
							<path d='M100.018 149.314l.789-4.255 8.288 1.538-.789 4.255-8.288-1.538z' fill='#8ED16F' />
							<path opacity='.05' d='M100.018 149.314l.789-4.255 8.288 1.538-.789 4.255-8.288-1.538z' fill='#000' />
							<path
								d='M106.293 148.333c.09-.481-.619-1.017-1.583-1.196-.964-.179-1.818.067-1.907.548-.089.482.62 1.017 1.584 1.196.963.179 1.817-.066 1.906-.548z'
								fill='#8ED16F'
							/>
							<path
								opacity='.1'
								d='M106.293 148.333c.09-.481-.619-1.017-1.583-1.196-.964-.179-1.818.067-1.907.548-.089.482.62 1.017 1.584 1.196.963.179 1.817-.066 1.906-.548z'
								fill='#000'
							/>
							<path d='M100.794 151.865l.789-4.255 8.289 1.539-.789 4.255-8.289-1.539z' fill='#8ED16F' />
							<path
								d='M107.068 150.885c.089-.481-.62-1.017-1.584-1.196-.964-.179-1.818.067-1.907.548-.089.482.62 1.017 1.584 1.196.964.179 1.817-.066 1.907-.548z'
								fill='#8ED16F'
							/>
							<path
								opacity='.1'
								d='M107.068 150.885c.089-.481-.62-1.017-1.584-1.196-.964-.179-1.818.067-1.907.548-.089.482.62 1.017 1.584 1.196.964.179 1.817-.066 1.907-.548z'
								fill='#000'
							/>
							<path d='M112.888 158.337l2.058-3.806 7.414 4.014-2.059 3.806-7.413-4.014z' fill='#8ED16F' />
							<path
								d='M119.161 159.335c.233-.431-.277-1.158-1.139-1.625-.863-.467-1.75-.496-1.983-.065-.233.43.277 1.158 1.139 1.625.862.467 1.75.496 1.983.065z'
								fill='#8ED16F'
							/>
							<path
								opacity='.1'
								d='M119.161 159.335c.233-.431-.277-1.158-1.139-1.625-.863-.467-1.75-.496-1.983-.065-.233.43.277 1.158 1.139 1.625.862.467 1.75.496 1.983.065z'
								fill='#000'
							/>
							<path d='M108.765 160.25l.789-4.255 8.288 1.539-.789 4.255-8.288-1.539z' fill='#8ED16F' />
							<path opacity='.05' d='M108.765 160.25l.789-4.255 8.288 1.539-.789 4.255-8.288-1.539z' fill='#000' />
							<path
								d='M115.038 159.27c.089-.482-.62-1.017-1.584-1.196-.964-.179-1.817.066-1.907.548-.089.482.62 1.017 1.584 1.196.964.179 1.818-.066 1.907-.548z'
								fill='#8ED16F'
							/>
							<path
								opacity='.1'
								d='M115.038 159.27c.089-.482-.62-1.017-1.584-1.196-.964-.179-1.817.066-1.907.548-.089.482.62 1.017 1.584 1.196.964.179 1.818-.066 1.907-.548z'
								fill='#000'
							/>
							<path d='M109.541 162.804l.789-4.255 8.288 1.539-.789 4.255-8.288-1.539z' fill='#8ED16F' />
							<path
								d='M115.816 161.824c.09-.481-.619-1.017-1.583-1.196-.964-.179-1.818.067-1.907.548-.089.482.62 1.017 1.583 1.196.964.179 1.818-.066 1.907-.548z'
								fill='#8ED16F'
							/>
							<path
								opacity='.1'
								d='M115.816 161.824c.09-.481-.619-1.017-1.583-1.196-.964-.179-1.818.067-1.907.548-.089.482.62 1.017 1.583 1.196.964.179 1.818-.066 1.907-.548z'
								fill='#000'
							/>
							<path d='M126.009 151.287l2.058-3.806 7.414 4.015-2.059 3.806-7.413-4.015z' fill='#8ED16F' />
							<path
								d='M132.278 152.284c.233-.431-.278-1.159-1.14-1.625-.862-.467-1.75-.497-1.983-.066-.233.431.277 1.159 1.14 1.626.862.466 1.75.496 1.983.065z'
								fill='#8ED16F'
							/>
							<path
								opacity='.1'
								d='M132.278 152.284c.233-.431-.278-1.159-1.14-1.625-.862-.467-1.75-.497-1.983-.066-.233.431.277 1.159 1.14 1.626.862.466 1.75.496 1.983.065z'
								fill='#000'
							/>
							<path d='M121.885 153.202l.788-4.255 8.289 1.538-.789 4.255-8.288-1.538z' fill='#8ED16F' />
							<path opacity='.05' d='M121.885 153.202l.788-4.255 8.289 1.538-.789 4.255-8.288-1.538z' fill='#000' />
							<path
								d='M128.158 152.221c.089-.482-.62-1.017-1.584-1.196-.964-.179-1.818.067-1.907.548-.089.482.62 1.017 1.584 1.196.964.179 1.817-.066 1.907-.548z'
								fill='#8ED16F'
							/>
							<path
								opacity='.1'
								d='M128.158 152.221c.089-.482-.62-1.017-1.584-1.196-.964-.179-1.818.067-1.907.548-.089.482.62 1.017 1.584 1.196.964.179 1.817-.066 1.907-.548z'
								fill='#000'
							/>
							<path d='M122.661 155.756l.789-4.255 8.288 1.538-.789 4.255-8.288-1.538z' fill='#8ED16F' />
							<path
								d='M128.936 154.776c.089-.482-.62-1.017-1.583-1.196-.964-.179-1.818.066-1.907.548-.09.481.619 1.017 1.583 1.196.964.179 1.818-.067 1.907-.548z'
								fill='#8ED16F'
							/>
							<path
								opacity='.1'
								d='M128.936 154.776c.089-.482-.62-1.017-1.583-1.196-.964-.179-1.818.066-1.907.548-.09.481.619 1.017 1.583 1.196.964.179 1.818-.067 1.907-.548z'
								fill='#000'
							/>
							<defs>
								<linearGradient id='paint0_linear' x1='174' y1='145' x2='174' y2='62' gradientUnits='userSpaceOnUse'>
									<stop stopColor='gray' stopOpacity='.25' />
									<stop offset='.54' stopColor='gray' stopOpacity='.12' />
									<stop offset='1' stopColor='gray' stopOpacity='.1' />
								</linearGradient>
								<linearGradient
									id='paint1_linear'
									x1='215.004'
									y1='153.992'
									x2='215.004'
									y2='26.01'
									gradientUnits='userSpaceOnUse'
								>
									<stop stopColor='gray' stopOpacity='.25' />
									<stop offset='.54' stopColor='gray' stopOpacity='.12' />
									<stop offset='1' stopColor='gray' stopOpacity='.1' />
								</linearGradient>
							</defs>
						</svg>
					</div>
				</div>
				<div className={css(styleSheet.right)}>
					<div className={css(styleSheet.monthlyPercent)}>
						{this.mAccountSnapshotsVM?.summary?.totalRenewalPercent >= 0
							? this.mAccountSnapshotsVM.summary.totalRenewalPercent.toString() + '%'
							: '??%'}
					</div>
					<div className={css(styleSheet.monthName)}>
						{moment().format('MMMM')}
						<br />
						Renewals
					</div>
					<button className={css(styleSheet.moarButton)} onClick={this.onMonthlyRenewalClicked}>
						<span className={css(styleSheet.moarText)}>{'MOAR >>>'}</span>
					</button>
				</div>
			</div>
		);
	}

	private onMonthlyRenewalClicked = () => {
		const { history } = this.props;
		history.push({ pathname: '/reports/monthly', state: { month: 'this' } });
	};
}

const BenjaminsSectionAsObserver = observer(_BenjaminsSection);
const BenjaminsSectionWithRouter = withRouter(BenjaminsSectionAsObserver);
export const BenjaminsSection = inject(UserSessionViewModelKey, ErrorMessagesViewModelKey)(BenjaminsSectionWithRouter);
